/**
 * Halsband-Konfigurator
 * Jagdnasen-Shop · Haketing e-commerce GmbH
 * Dawn Theme – Snippet-Version (kein Shopify CLI erforderlich)
 */

(function () {
  'use strict';

  function formatMoney(cents) {
    return (cents / 100).toLocaleString('de-DE', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
    });
  }

  function parseJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); }
    catch (e) { console.error('[Konfigurator] JSON-Fehler:', e); return null; }
  }

  // ── Hauptklasse ──────────────────────────────────────────────

  class Konfigurator {
    constructor(pid) {
      this.pid = pid;
      this.el  = document.getElementById('konfigurator-' + pid);
      if (!this.el) return;

      this.data     = parseJSON(document.getElementById('konfigurator-data-'     + pid));
      this.variants = parseJSON(document.getElementById('konfigurator-variants-' + pid));
      this.options  = parseJSON(document.getElementById('konfigurator-options-'  + pid));

      if (!this.data || !this.variants || !this.options) {
        console.error('[Konfigurator] Daten fehlen für Produkt:', pid);
        return;
      }

      this.state = {
        farbe1:        null,
        farbe2:        null,
        optionValues:  {},   // { optionIndex: selectedValue } für alle Varianten-Optionen außer Verschluss/Druck
        verschluss:    'Zinkdruckguss',
        druckJa:       this.data.druckImmerAktiv ? true : false,
        druckName:     '',
        druckTelefon:  '',
        druckMotiv:    null,
        gravurJa:      this.data.gravurVerfuegbar ? true : false,
        gravurName:    '',
        gravurTelefon: '',
        druckFarbe:    null,
        druckText:     '',
        extraWerte:    {},   // { extraIndex: selectedValue/text } für generische Extra-Optionen
      };

      this.init();
    }

    init() {
      this.renderSwatches('farbe1', this.data.farbe1.farben);
      const f2 = typeof this.data.farbe2.farben === 'string' ? JSON.parse(this.data.farbe2.farben) : this.data.farbe2.farben;
      if (f2 && f2.length > 0) {
        this.renderSwatches('farbe2', f2);
      }
      this.renderVerschluss();
      if (this.data.druckVerfuegbar) this.renderMotive();
      if (this.data.druckFarbeArr && this.data.druckFarbeArr.length > 0) {
        this.renderSwatches('druckFarbe', this.data.druckFarbeArr);
      }
      this.initExtraOptionen();
      this.bindEvents();
      // "Default Title" automatisch setzen (Produkte mit nur einer Variante)
      const names = this.options.names || [];
      names.forEach((name, i) => {
        if (name === 'Title') this.state.optionValues[i] = 'Default Title';
      });
      this.selectVerschluss('Zinkdruckguss');
      this.updateButton();
      // Nativen Shopify-Preis oben als "ab X €" kennzeichnen (Referenzpreis)
      // Entscheidung Kundin offen: Option A = "ab X €" (aktuell), Option B = Preis synchronisieren
      // → Rückbau-Anleitung: diese 4 Zeilen entfernen, Funktion updateNativeAbPreis() entfernen
      this.updateNativeAbPreis();
      this.updatePreview();
    }

    updateNativeAbPreis() {
      const nativeEl = document.querySelector('.price__regular .price-item--regular')
                    || document.querySelector('.price__sale .price-item--sale');
      if (!nativeEl) return;
      const base = formatMoney(this.data.basePrice);
      nativeEl.textContent = 'ab ' + base;
    }

    // ── Swatches ─────────────────────────────────────────────

    renderSwatches(group, farben) {
      const c = this.el.querySelector('[data-group="' + group + '"]');
      if (!c || !farben) return;
      const arr = typeof farben === 'string' ? JSON.parse(farben) : farben;
      if (!Array.isArray(arr) || arr.length === 0) return;
      c.innerHTML = arr.map(f => {
        const hell = this.isLight(f.hex);
        return `<button type="button"
          class="konfigurator__swatch${hell ? ' konfigurator__swatch--light' : ''}"
          data-group="${group}"
          data-farbe="${this.esc(f.name)}"
          style="background-color:${f.hex}"
          title="${this.esc(f.name)}"
          aria-label="${this.esc(f.name)}"></button>`;
      }).join('');

      // Einzelne Farbe automatisch vorauswählen
      if (arr.length === 1) {
        this.state[group] = arr[0].name;
        const nm = this.el.querySelector(`[data-selected="${group}"]`);
        if (nm) nm.textContent = arr[0].name;
        const swatch = c.querySelector('.konfigurator__swatch');
        if (swatch) swatch.classList.add('konfigurator__swatch--active');
      }
    }

    // ── Verschluss ───────────────────────────────────────────

    renderVerschluss() {
      const c = this.el.querySelector('.konfigurator__verschluss-grid');
      if (!c) return;
      const opts = [
        { id: 'Zinkdruckguss', aufpreis: 0 },
        { id: 'Messing',       aufpreis: this.data.aufpreise.Messing },
        { id: 'Edelstahl',     aufpreis: this.data.aufpreise.Edelstahl },
      ];
      c.innerHTML = opts.map(v => {
        const img     = this.data.verschlussImages[v.id];
        const preisTx = v.aufpreis > 0 ? `+${v.aufpreis},00 €` : 'inklusive';
        const imgTag  = img
          ? `<img src="${img}" alt="${v.id}" class="konfigurator__verschluss-img" loading="lazy">`
          : `<span class="konfigurator__verschluss-icon">🔩</span>`;
        return `<button type="button" class="konfigurator__verschluss-btn" data-verschluss="${v.id}" title="${v.id} (${preisTx})">
          ${imgTag}
          <span class="konfigurator__verschluss-label">${v.id}</span>
          <span class="konfigurator__verschluss-preis">${preisTx}</span>
        </button>`;
      }).join('');
    }

    // ── Tiermotive ───────────────────────────────────────────

    renderMotive() {
      const c = document.getElementById('konfigurator-motive-' + this.pid);
      if (!c) return;
      const anzahl   = parseInt(this.data.motivAnzahl) || 0;
      const basisUrl = this.data.motivBasisUrl || '';

      let html = `<button type="button" class="konfigurator__motiv-btn konfigurator__motiv-btn--active" data-motiv="" aria-label="Kein Tiermotiv">
        <span class="konfigurator__motiv-kein">kein<br>Motiv</span>
      </button>`;

      for (let i = 1; i <= anzahl; i++) {
        const n = String(i).padStart(2, '0');
        html += `<button type="button" class="konfigurator__motiv-btn" data-motiv="motiv-${n}" aria-label="Tiermotiv ${i}">
          <img src="${basisUrl}motiv-${n}.png" alt="Tiermotiv ${i}" loading="lazy" width="60" height="60">
        </button>`;
      }
      c.innerHTML = html;
    }

    // ── Events ───────────────────────────────────────────────

    bindEvents() {
      this.el.addEventListener('click', e => {
        const sw = e.target.closest('.konfigurator__swatch');
        if (sw) return this.handleFarbe(sw);

        const sz = e.target.closest('.konfigurator__size-btn[data-option-index]');
        if (sz) return this.handleOption(sz);

        const eb = e.target.closest('[data-extra-btn]');
        if (eb) return this.handleExtraBtn(eb);

        const et = e.target.closest('[data-extra-toggle]');
        if (et) return this.handleExtraToggle(et);

        const vb = e.target.closest('.konfigurator__verschluss-btn');
        if (vb) return this.selectVerschluss(vb.dataset.verschluss);

        const dt = e.target.closest('[data-druck]');
        if (dt) return this.handleDruck(dt.dataset.druck === 'ja');

        // Gravur ist Pflichtfeld – kein Toggle nötig

        const mb = e.target.closest('.konfigurator__motiv-btn');
        if (mb) return this.handleMotiv(mb);
      });

      this.el.addEventListener('change', e => {
        if (e.target.matches('[data-druck-feld]'))  this.handleDruckFeld(e.target);
        if (e.target.matches('[data-gravur-feld]')) this.handleGravurFeld(e.target);
      });

      this.el.addEventListener('input', e => {
        if (e.target.matches('.konfigurator__input')) this.syncTexte();
        if (e.target.matches('[data-extra-textarea]') || e.target.matches('[data-extra-text]')) {
          this.handleExtraInput(e.target);
        }
      });

      this.el.addEventListener('change', e => {
        if (e.target.matches('[data-extra-select]')) this.handleExtraSelect(e.target);
      });

      const atc = document.getElementById('konfigurator-atc-' + this.pid);
      if (atc) atc.addEventListener('click', () => this.addToCart());
    }

    // ── Handler ──────────────────────────────────────────────

    handleFarbe(swatch) {
      const group = swatch.dataset.group;
      this.el.querySelectorAll(`[data-group="${group}"].konfigurator__swatch`).forEach(s => {
        s.classList.remove('konfigurator__swatch--active');
      });
      swatch.classList.add('konfigurator__swatch--active');
      this.state[group] = swatch.dataset.farbe;
      const nm = this.el.querySelector(`[data-selected="${group}"]`);
      if (nm) nm.textContent = swatch.dataset.farbe;
      this.updatePreview();
      this.updateButton();
    }

    handleOption(btn) {
      const idx = parseInt(btn.dataset.optionIndex);
      this.el.querySelectorAll(`.konfigurator__size-btn[data-option-index="${idx}"]`)
        .forEach(b => b.classList.remove('konfigurator__size-btn--active'));
      btn.classList.add('konfigurator__size-btn--active');
      this.state.optionValues[idx] = btn.dataset.value;
      const nm = this.el.querySelector(`[data-selected="option-${idx}"]`);
      if (nm) nm.textContent = btn.dataset.value;
      this.updateConditions();
      this.updatePrice();
      this.updateButton();
    }

    updateConditions() {
      const extras = this.data.extraOptionen || [];
      const names  = this.options.names || [];
      extras.forEach((opt, i) => {
        if (!opt.bedingung) return;
        const parts   = opt.bedingung.split(':');
        if (parts.length < 2) return;
        const condName = parts[0].trim();
        const condVal  = parts[1].trim();
        const condIdx  = names.indexOf(condName);
        const current  = condIdx >= 0 ? this.state.optionValues[condIdx] : null;
        const visible  = current === condVal;
        const section  = this.el.querySelector(`[data-extra-section="${i}"]`);
        if (section) section.hidden = !visible;
        if (!visible) {
          const typ = (opt.typ || '').toLowerCase();
          if (typ !== 'toggle') delete this.state.extraWerte[i];
        }
      });
    }

    selectVerschluss(verschluss) {
      this.state.verschluss = verschluss;
      this.el.querySelectorAll('.konfigurator__verschluss-btn').forEach(b => {
        b.classList.toggle('konfigurator__verschluss-btn--active', b.dataset.verschluss === verschluss);
      });
      const nm = this.el.querySelector('[data-selected="verschluss"]');
      if (nm) nm.textContent = verschluss;
      this.updatePreview();
      this.updatePrice();
      this.updateButton();
    }

    // ── Vorschau ─────────────────────────────────────────────

    getHexForFarbe(group) {
      const name = this.state[group];
      if (!name || !this.data[group]) return null;
      let arr = this.data[group].farben;
      if (typeof arr === 'string') { try { arr = JSON.parse(arr); } catch(e) { return null; } }
      if (!Array.isArray(arr)) return null;
      const match = arr.find(f => f.name === name);
      return match ? match.hex : null;
    }

    updatePreview() {
      const svg = document.getElementById('kv-svg-' + this.pid);
      if (!svg) return;

      const hex1 = this.getHexForFarbe('farbe1');
      const hex2 = this.getHexForFarbe('farbe2');

      // Band 1 (Hauptfarbe)
      if (hex1) {
        svg.querySelectorAll('.kv-band1').forEach(el => el.setAttribute('fill', hex1));
      }

      // Band 2 (Schlaufe / Akzentfarbe)
      const band2g = document.getElementById('kv-band2-g-' + this.pid);
      if (band2g) {
        let f2 = this.data.farbe2.farben;
        if (typeof f2 === 'string') { try { f2 = JSON.parse(f2); } catch(e) { f2 = []; } }
        const hasBand2 = Array.isArray(f2) && f2.length > 0;
        if (hasBand2 && hex2) {
          band2g.style.display = '';
          svg.querySelectorAll('.kv-band2').forEach(el => el.setAttribute('fill', hex2));
        } else if (hex1) {
          // Einfarbig: Keeper in gleicher Farbe
          svg.querySelectorAll('.kv-band2').forEach(el => el.setAttribute('fill', hex1));
        }
      }

      // Beschlag (Hardware)
      const hwMap = {
        'Zinkdruckguss': { fill: '#C0C0C0', stroke: '#8A8A8A' },
        'Messing':       { fill: '#D4A847', stroke: '#9E7A28' },
        'Edelstahl':     { fill: '#E0E0E0', stroke: '#A8A8A8' },
      };
      const hw = hwMap[this.state.verschluss] || hwMap['Zinkdruckguss'];
      svg.querySelectorAll('.kv-hw-fill').forEach(el => el.setAttribute('fill', hw.fill));
      svg.querySelectorAll('.kv-hw-stroke').forEach(el => el.setAttribute('stroke', hw.stroke));
    }

    handleDruck(ja) {
      this.state.druckJa = ja;
      this.el.querySelectorAll('[data-druck]').forEach(b => {
        b.classList.toggle('konfigurator__toggle-btn--active', (b.dataset.druck === 'ja') === ja);
      });
      const details = document.getElementById('konfigurator-druckdetails-' + this.pid);
      if (details) details.hidden = !ja;
      this.updatePrice();
      this.updateButton();
    }

    handleMotiv(btn) {
      this.el.querySelectorAll('.konfigurator__motiv-btn').forEach(b => b.classList.remove('konfigurator__motiv-btn--active'));
      btn.classList.add('konfigurator__motiv-btn--active');
      this.state.druckMotiv = btn.dataset.motiv || null;
    }

    handleDruckFeld(cb) {
      const feld = document.getElementById('eingabe-' + cb.dataset.druckFeld + '-' + this.pid);
      if (feld) feld.hidden = !cb.checked;
      this.updateButton();
    }

    handleGravur(ja) {
      this.state.gravurJa = ja;
      this.el.querySelectorAll('[data-gravur]').forEach(b => {
        b.classList.toggle('konfigurator__toggle-btn--active', (b.dataset.gravur === 'ja') === ja);
      });
      const details = document.getElementById('konfigurator-gravurdetails-' + this.pid);
      if (details) details.hidden = !ja;
      this.updatePrice();
      this.updateButton();
    }

    handleGravurFeld(cb) {
      const feld = document.getElementById('gravur-eingabe-' + cb.dataset.gravurFeld + '-' + this.pid);
      if (feld) feld.hidden = !cb.checked;
      this.updateButton();
    }

    // ── Extra-Optionen ───────────────────────────────────────

    initExtraOptionen() {
      const extras = this.data.extraOptionen || [];
      extras.forEach((opt, i) => {
        const typ = (opt.typ || '').toLowerCase();
        if (typ === 'toggle' && opt.werte && opt.werte.length > 0) {
          // Erster Wert ist Voreinstellung
          this.state.extraWerte[i] = opt.werte[0];
        }
        if (typ === 'dropdown' && opt.platzhalter) {
          // Platzhalter-Wert als Vorauswahl
          this.state.extraWerte[i] = opt.platzhalter;
        }
      });
    }

    handleExtraBtn(btn) {
      const idx = parseInt(btn.dataset.extraIndex);
      this.el.querySelectorAll(`[data-extra-btn][data-extra-index="${idx}"]`)
        .forEach(b => b.classList.remove('konfigurator__size-btn--active'));
      btn.classList.add('konfigurator__size-btn--active');
      this.state.extraWerte[idx] = btn.dataset.value;
      const nm = this.el.querySelector(`[data-selected="extra-${idx}"]`);
      if (nm) nm.textContent = btn.dataset.value;
      this.updatePrice();
      this.updateButton();
    }

    handleExtraToggle(btn) {
      const idx = parseInt(btn.dataset.extraIndex);
      this.el.querySelectorAll(`[data-extra-toggle][data-extra-index="${idx}"]`)
        .forEach(b => b.classList.remove('konfigurator__toggle-btn--active'));
      btn.classList.add('konfigurator__toggle-btn--active');
      this.state.extraWerte[idx] = btn.dataset.value;
      const nm = this.el.querySelector(`[data-selected="extra-${idx}"]`);
      if (nm) nm.textContent = btn.dataset.value;
      this.updatePrice();
      this.updateButton();
    }

    handleExtraSelect(select) {
      const idx = parseInt(select.dataset.extraIndex);
      this.state.extraWerte[idx] = select.value;
      this.updatePrice();
      this.updateButton();
    }

    handleExtraInput(input) {
      const idx = parseInt(input.dataset.extraIndex);
      this.state.extraWerte[idx] = input.value.trim();
      this.updateButton();
    }

    syncTexte() {
      // Dummy-Modus: einzeiliger Drucktext
      const dt = document.getElementById('druck-text-' + this.pid);
      if (dt) { this.state.druckText = dt.value.trim(); }
      else { this.state.druckText = ''; }

      // Halsband-Modus: Name + Telefon
      const n = document.getElementById('druck-text-name-'    + this.pid);
      const t = document.getElementById('druck-text-telefon-' + this.pid);
      if (n) { n.value = n.value.toUpperCase(); this.state.druckName = n.value.trim(); }
      else { this.state.druckName = ''; }
      this.state.druckTelefon = t ? t.value.trim() : '';

      const gn = document.getElementById('gravur-text-name-'    + this.pid);
      const gt = document.getElementById('gravur-text-telefon-' + this.pid);
      if (gn) { gn.value = gn.value.toUpperCase(); this.state.gravurName = gn.value.trim(); }
      else { this.state.gravurName = ''; }
      this.state.gravurTelefon = gt ? gt.value.trim() : '';

      this.updateButton();
    }

    // ── Preis ────────────────────────────────────────────────

    updatePrice() {
      const v = this.findVariant();
      const names = this.options.names || [];
      let total;

      if (v) {
        // Variante gefunden: Variantenpreis (enthält bereits Verschluss+Druck wenn als Variante)
        total = v.price;
        // Nur manuell addieren wenn NICHT als Shopify-Variante abgebildet
        if (!names.includes('Verschluss') && this.state.verschluss !== 'Zinkdruckguss') {
          total += (this.data.aufpreise[this.state.verschluss] || 0) * 100;
        }
        if (!names.includes('Druck') && this.state.druckJa) {
          total += this.data.aufpreise.Druck * 100;
        }
        if (this.state.gravurJa && this.data.aufpreise.Gravur > 0) {
          total += this.data.aufpreise.Gravur * 100;
        }
      } else {
        // Keine vollständige Variante → Preis aus bereits gewählten Optionen schätzen
        const partialMatches = this.variants.filter(variant => {
          const o = [variant.option1, variant.option2, variant.option3];
          for (let i = 0; i < names.length; i++) {
            const name = names[i];
            if (name === 'Title') continue;
            if (name === 'Verschluss') {
              // Verschluss als Shopify-Variante: nach aktuellem State filtern
              if (o[i] !== this.state.verschluss) return false;
              continue;
            }
            if (name === 'Druck') {
              // Wenn Druck als Shopify-Variante: nach aktuellem Druck-State filtern
              const druckVal = this.state.druckJa ? 'Mit Druck' : 'Ohne Druck';
              if (o[i] !== druckVal) return false;
              continue;
            }
            if (!this.state.optionValues[i]) continue; // noch nicht gewählt → ignorieren
            if (o[i] !== this.state.optionValues[i]) return false;
          }
          return true;
        });
        total = partialMatches.length > 0
          ? Math.min(...partialMatches.map(v => v.price))
          : this.data.basePrice;
        if (!names.includes('Verschluss') && this.state.verschluss !== 'Zinkdruckguss') {
          total += (this.data.aufpreise[this.state.verschluss] || 0) * 100;
        }
        if (!names.includes('Druck') && this.state.druckJa) {
          total += this.data.aufpreise.Druck * 100;
        }
        if (this.state.gravurJa && this.data.aufpreise.Gravur > 0) {
          total += this.data.aufpreise.Gravur * 100;
        }
      }

      // Extra-Optionen Aufpreise
      const extras = this.data.extraOptionen || [];
      extras.forEach((opt, i) => {
        const typ = (opt.typ || '').toLowerCase();
        if (typ !== 'buttons' && typ !== 'toggle') return;
        const val = this.state.extraWerte[i];
        if (!val) return;
        const wIdx = (opt.werte || []).indexOf(val);
        if (wIdx >= 0 && opt.aufpreise && opt.aufpreise[wIdx]) {
          total += opt.aufpreise[wIdx] * 100;
        }
      });

      const el = document.getElementById('konfigurator-preis-' + this.pid);
      if (el) el.textContent = formatMoney(total);

      // Aufpreis-Aufschlüsselung (immer anzeigen wenn Aufpreis vorhanden)
      const bd = document.getElementById('konfigurator-aufpreise-' + this.pid);
      if (bd) {
        const lines = [];
        if (this.state.verschluss !== 'Zinkdruckguss') {
          const ap = (this.data.aufpreise[this.state.verschluss] || 0) * 100;
          if (ap > 0) lines.push(`+ ${this.state.verschluss}: ${formatMoney(ap)}`);
        }
        if (this.state.druckJa && this.data.aufpreise.Druck > 0) {
          lines.push(`+ Mit Druck: ${formatMoney(this.data.aufpreise.Druck * 100)}`);
        }
        if (this.state.gravurJa && this.data.aufpreise.Gravur > 0) {
          lines.push(`+ Gravur: ${formatMoney(this.data.aufpreise.Gravur * 100)}`);
        }
        extras.forEach((opt, i) => {
          const typ = (opt.typ || '').toLowerCase();
          if (typ !== 'buttons' && typ !== 'toggle') return;
          const val = this.state.extraWerte[i];
          if (!val) return;
          const wIdx = (opt.werte || []).indexOf(val);
          if (wIdx >= 0 && opt.aufpreise && opt.aufpreise[wIdx] > 0) {
            lines.push(`+ ${opt.label} (${val}): ${formatMoney(opt.aufpreise[wIdx] * 100)}`);
          }
        });
        if (lines.length > 0) {
          bd.innerHTML = lines.map(l => `<span>${l}</span>`).join('');
          bd.hidden = false;
        } else {
          bd.hidden = true;
        }
      }
    }

    // ── Variante finden ──────────────────────────────────────

    findVariant() {
      const names = this.options.names || [];
      // Alle nicht-speziellen Optionen müssen gewählt sein
      for (let i = 0; i < names.length; i++) {
        const name = names[i];
        if (name === 'Verschluss' || name === 'Druck') continue;
        if (!this.state.optionValues[i]) return null;
      }
      return this.variants.find(v => {
        const o = [v.option1, v.option2, v.option3];
        for (let i = 0; i < names.length; i++) {
          const name = names[i];
          if (name === 'Title') {
            // auto-selected, immer "Default Title"
          } else if (name === 'Verschluss') {
            if (o[i] !== this.state.verschluss) return false;
          } else if (name === 'Druck') {
            const druck = this.state.druckJa ? 'Mit Druck' : 'Ohne Druck';
            if (o[i] !== druck) return false;
          } else {
            if (o[i] !== this.state.optionValues[i]) return false;
          }
        }
        return true;
      }) || null;
    }

    // ── Validierung ──────────────────────────────────────────

    validate() {
      const err = [];
      if (this.data.farbe1.farben.length > 0 && !this.state.farbe1)
        err.push(this.data.farbe1.label + ' bitte auswählen.');
      if (this.data.farbe2.farben.length > 0 && !this.state.farbe2)
        err.push(this.data.farbe2.label + ' bitte auswählen.');
      const names = this.options.names || [];
      names.forEach((name, i) => {
        if (name === 'Verschluss' || name === 'Druck' || name === 'Title') return;
        if (!this.state.optionValues[i])
          err.push('Bitte ' + name + ' auswählen.');
      });

      const extras = this.data.extraOptionen || [];
      extras.forEach((opt, i) => {
        const section = this.el.querySelector(`[data-extra-section="${i}"]`);
        if (section && section.hidden) return;
        if (!opt.pflichtfeld) return;
        const typ = (opt.typ || '').toLowerCase();
        const val = this.state.extraWerte[i];
        if (typ === 'toggle') return;
        if (!val || val.trim() === '') {
          if (typ === 'dropdown') {
            err.push(`${opt.label} bitte auswählen.`);
          } else {
            err.push(`${opt.label} bitte ausfüllen.`);
          }
        }
      });

      if (this.state.druckJa) {
        if (this.data.druckNurTelefon) {
          // Nur-Telefon-Modus (z.B. Schwedenfahne): nur Telefonnummer Pflicht
          if (!this.state.druckTelefon)
            err.push('Bitte die Telefonnummer eingeben.');
        } else if (this.data.druckFarbeArr && this.data.druckFarbeArr.length > 0) {
          // Dummy-Modus: Druckfarbe + Drucktext
          if (!this.state.druckFarbe)
            err.push('Bitte Druckfarbe auswählen.');
          if (!this.state.druckText)
            err.push('Bitte Drucktext eingeben.');
        } else {
          // Halsband-Modus: Name oder Telefon
          const nc = document.getElementById('druck-name-'    + this.pid);
          const tc = document.getElementById('druck-telefon-' + this.pid);
          const nj = nc && nc.checked;
          const tj = tc && tc.checked;
          if (!nj && !tj)
            err.push('Bitte Name oder Telefonnummer für den Druck wählen.');
          if (nj && !this.state.druckName)
            err.push('Bitte den Namen eingeben.');
          if (tj && !this.state.druckTelefon)
            err.push('Bitte die Telefonnummer eingeben.');
        }
      }

      if (this.state.gravurJa) {
        const gnc = document.getElementById('gravur-name-'    + this.pid);
        const gtc = document.getElementById('gravur-telefon-' + this.pid);
        const gnj = gnc && gnc.checked;
        const gtj = gtc && gtc.checked;
        if (!gnj && !gtj)
          err.push('Bitte Name oder Telefonnummer für die Gravur wählen.');
        if (gnj && !this.state.gravurName)
          err.push('Bitte den Namen für die Gravur eingeben.');
        if (gtj && !this.state.gravurTelefon)
          err.push('Bitte die Telefonnummer für die Gravur eingeben.');
      }

      return err;
    }

    updateButton() {
      const btn = document.getElementById('konfigurator-atc-' + this.pid);
      const err = document.getElementById('konfigurator-error-' + this.pid);
      if (!btn) return;

      const errors  = this.validate();
      const variant = this.findVariant();
      const ok      = errors.length === 0 && variant !== null;

      btn.disabled = !ok;
      if (err) {
        if (!ok && errors.length > 0) {
          err.innerHTML = errors.map(e => `<p>${e}</p>`).join('');
          err.hidden = false;
        } else {
          err.hidden = true;
        }
      }
    }

    // ── Warenkorb ────────────────────────────────────────────

    async addToCart() {
      const errors = this.validate();
      if (errors.length > 0) { this.updateButton(); return; }

      const variant = this.findVariant();
      if (!variant) return;

      const properties = {};
      const label1 = (this.data.farbe1.label || '').replace(/:+$/, '').trim();
      const label2 = (this.data.farbe2.label || '').replace(/:+$/, '').trim();
      if (this.state.farbe1 && label1) properties[label1] = this.state.farbe1;
      if (this.state.farbe2 && label2) properties[label2] = this.state.farbe2;
      // Varianten-Optionen (Größe, Breite etc.) nicht als Properties schreiben –
      // sie erscheinen bereits automatisch im Warenkorb über den Variant-Titel.

      // Extra-Optionen als Line Item Properties
      const extras = this.data.extraOptionen || [];
      extras.forEach((opt, i) => {
        const section = this.el.querySelector(`[data-extra-section="${i}"]`);
        if (section && section.hidden) return;
        const val = this.state.extraWerte[i];
        const typ = (opt.typ || '').toLowerCase();
        if (typ === 'toggle') {
          // Toggle immer schreiben (auch "Nein" ist relevant)
          properties[opt.label] = val || (opt.werte && opt.werte[0]) || '';
        } else if (val && val.trim() !== '') {
          properties[opt.label] = val.trim();
        }
      });

      if (this.state.druckJa) {
        if (this.data.druckNurTelefon) {
          // Nur-Telefon-Modus (z.B. Schwedenfahne): nur Telefonnummer
          properties['Druck Telefonnummer'] = this.state.druckTelefon;
        } else {
          properties['Mit Druck'] = 'Ja';
          if (this.state.druckFarbe) properties['Druckfarbe'] = this.state.druckFarbe;
          if (this.data.druckFarbeArr && this.data.druckFarbeArr.length > 0) {
            // Dummy-Modus
            if (this.state.druckText) properties['Drucktext'] = this.state.druckText;
          } else {
            // Halsband-Modus
            if (this.state.druckName)    properties['Druck Name']          = this.state.druckName;
            if (this.state.druckTelefon) properties['Druck Telefonnummer'] = this.state.druckTelefon;
            if (this.state.druckMotiv)   properties['Druck: Tiermotiv']    = this.state.druckMotiv;
          }
        }
      }

      if (this.state.gravurJa) {
        properties['Gravur'] = 'Ja';
        if (this.state.gravurName)    properties['Gravur Name']         = this.state.gravurName;
        if (this.state.gravurTelefon) properties['Gravur Telefonnummer'] = this.state.gravurTelefon;
      }

      // Lade-Zustand
      const btn     = document.getElementById('konfigurator-atc-' + this.pid);
      const txtEl   = btn.querySelector('.konfigurator__atc-text');
      const spinEl  = btn.querySelector('.konfigurator__atc-spinner');
      btn.disabled  = true;
      if (txtEl)  txtEl.hidden  = true;
      if (spinEl) spinEl.hidden = false;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ id: variant.id, quantity: 1, properties }),
        });

        if (!res.ok) throw new Error(res.status);

        // Dawn Cart-Drawer öffnen
        document.body.dispatchEvent(new CustomEvent('cart-drawer:open', { bubbles: true }));

        // Cart-Icon-Bubble über Section Rendering aktualisieren (Dawn 15)
        const cartBubble = document.getElementById('cart-icon-bubble');
        const sectionEl  = cartBubble && cartBubble.closest('.shopify-section');
        const sectionId  = sectionEl && sectionEl.id.replace('shopify-section-', '');
        if (sectionId) {
          fetch('/?sections=' + sectionId)
            .then(r => r.json())
            .then(data => {
              if (!data[sectionId]) return;
              const doc = new DOMParser().parseFromString(data[sectionId], 'text/html');
              const newBubble = doc.getElementById('cart-icon-bubble');
              if (newBubble && cartBubble) cartBubble.innerHTML = newBubble.innerHTML;
            });
        }

      } catch (e) {
        console.error('[Konfigurator] Cart-Fehler:', e);
        const errEl = document.getElementById('konfigurator-error-' + this.pid);
        if (errEl) {
          errEl.innerHTML = '<p>Fehler beim Hinzufügen. Bitte versuche es erneut.</p>';
          errEl.hidden = false;
        }
      } finally {
        btn.disabled  = false;
        if (txtEl)  txtEl.hidden  = false;
        if (spinEl) spinEl.hidden = true;
        this.updateButton();
      }
    }

    // ── Hilfsfunktionen ──────────────────────────────────────

    isLight(hex) {
      const r = parseInt(hex.slice(1,3),16);
      const g = parseInt(hex.slice(3,5),16);
      const b = parseInt(hex.slice(5,7),16);
      return (r*299 + g*587 + b*114) / 1000 > 128;
    }

    esc(s) {
      return String(s).replace(/"/g,'&quot;').replace(/'/g,'&#39;');
    }
  }

  // ── Initialisierung ──────────────────────────────────────────

  function initAll() {
    document.querySelectorAll('[id^="konfigurator-data-"]').forEach(el => {
      const pid = el.id.replace('konfigurator-data-', '');
      if (!el.dataset.initialized) {
        el.dataset.initialized = '1';
        new Konfigurator(pid);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[id^="konfigurator-data-"]').forEach(el => delete el.dataset.initialized);
    initAll();
  });

})();
